'use client';

import { Fade, Slide, Zoom } from 'react-awesome-reveal';
import { ReactNode } from 'react';

type AnimationType = 'fade' | 'slide' | 'zoom';
type Direction = 'up' | 'down' | 'left' | 'right';

interface AnimatedBlockProps {
  children: ReactNode;
  type?: AnimationType;
  delay?: number;
  duration?: number;
  triggerOnce?: boolean;
  className?: string;
  direction?: Direction;
  [key: string]: any;
}

const animationMap = {
  fade: Fade,
  slide: Slide,
  zoom: Zoom,
};

export default function AnimatedBlock({
  children,
  type = 'fade',
  delay = 0,
  duration = 1000,
  triggerOnce = false,
  className = '',
  direction,
  ...props
}: AnimatedBlockProps) {
  const Animation = animationMap[type] || Fade;

  const animationProps: {
    delay: number;
    duration: number;
    triggerOnce: boolean;
    className: string;
    direction?: Direction;
    [key: string]: any;
  } = {
    delay,
    duration,
    triggerOnce,
    className,
    ...props,
  };

  if (type === 'slide') {
    animationProps.direction = direction || 'up';
  } else {
    delete animationProps.direction;
  }

  return <Animation {...animationProps}>{children}</Animation>;
}